import { Link } from 'react-router-dom';
import { Phone, Truck, Shield, Banknote } from 'lucide-react';

export function MobileFooter() {
    return (
        <div className="md:hidden bg-gray-50 border-t border-gray-200 pb-20">
            {/* Trust Badges */}
            <div className="grid grid-cols-2 gap-3 p-4">
                <TrustBadge icon={Truck} text="Livraison 58 wilayas" />
                <TrustBadge icon={Banknote} text="Paiement à la livraison" />
                <TrustBadge icon={Shield} text="Produits garantis" />
                <TrustBadge icon={Phone} text="Support 7j/7" />
            </div>

            {/* Quick Links */}
            <div className="px-4 py-3 border-t border-gray-200">
                <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm">
                    <Link to="/shop" className="text-gray-600 hover:text-primary-500">
                        Boutique
                    </Link>
                    <Link to="/contact" className="text-gray-600 hover:text-primary-500">
                        Contact
                    </Link>
                    <Link to="/faq" className="text-gray-600 hover:text-primary-500">
                        FAQ
                    </Link>
                    <Link to="/privacy" className="text-gray-600 hover:text-primary-500">
                        Confidentialité
                    </Link>
                </div>
            </div>

            {/* Copyright */}
            <div className="px-4 py-3 text-center text-xs text-gray-400">
                © {new Date().getFullYear()} Marchego. Tous droits réservés.
            </div>
        </div>
    );
}

function TrustBadge({ icon: Icon, text }: { icon: React.ElementType; text: string }) {
    return (
        <div className="flex items-center gap-2 p-3 bg-white rounded-xl border border-gray-100">
            <div className="w-8 h-8 bg-primary-50 rounded-lg flex items-center justify-center flex-shrink-0">
                <Icon className="w-4 h-4 text-primary-500" />
            </div>
            <span className="text-xs font-medium text-gray-700 leading-tight">{text}</span>
        </div>
    );
}
